export default "__VITE_ASSET__xvtHquKJ__"